(function () {
  "use strict";

  const kgHiddenClass = "kg-hidden-unavailable-option";
  const kgHiddenWrapperClass = "kg-hidden-option-wrapper";

  function kgInjectHideStyle() {
    if (document.getElementById("kg-custom-unavailable-style")) return;
    const style = document.createElement("style");
    style.id = "kg-custom-unavailable-style";
    style.textContent = `.${kgHiddenClass}{display:none!important;}.${kgHiddenWrapperClass}{display:none!important;}`;
    document.head.appendChild(style);
  }

  function kgGetCheckedValueByPosition(kgVariantOptionsElement, kgPosition) {
    const kgChecked = kgVariantOptionsElement.querySelector(
      `input[data-position="${kgPosition}"]:checked`,
    );
    return kgChecked ? kgChecked.value : null;
  }

  function kgGetOptionMeta(kgVariantOptionsElement, kgPosition, kgValue, kgVariants) {
    const kgOptionKey = `option${kgPosition}`;
    const kgPrevious1 = kgGetCheckedValueByPosition(kgVariantOptionsElement, 1);
    const kgPrevious2 = kgPosition === 3 ? kgGetCheckedValueByPosition(kgVariantOptionsElement, 2) : null;

    const kgMatchingVariants = kgVariants.filter((kgVariant) => {
      if (kgPosition === 2) {
        return kgVariant.option1 === kgPrevious1 && kgVariant[kgOptionKey] === kgValue;
      }
      return (
        kgVariant.option1 === kgPrevious1 &&
        kgVariant.option2 === kgPrevious2 &&
        kgVariant[kgOptionKey] === kgValue
      );
    });

    const kgExists = kgMatchingVariants.length > 0;
    const kgAvailable = kgMatchingVariants.some((kgVariant) => kgVariant.available === true);

    return {
      exists: kgExists,
      available: kgAvailable,
    };
  }

  function kgGetItemNodeFromInput(kgInput) {
    return kgInput.closest("li");
  }

  function kgUpdateOptionVisibility(kgVariantOptionsElement, kgPosition, kgVariants) {
    const kgInputs = Array.from(
      kgVariantOptionsElement.querySelectorAll(`input[type="radio"][data-position="${kgPosition}"]`),
    );
    let kgFirstAvailableInput = null;

    kgInputs.forEach((kgInput) => {
      const kgItem = kgGetItemNodeFromInput(kgInput);
      if (!kgItem) return;

      const kgMeta = kgGetOptionMeta(kgVariantOptionsElement, kgPosition, kgInput.value, kgVariants);
      const kgIsUnavailable = !kgMeta.exists; // hide only truly unavailable combinations

      kgItem.classList.toggle(kgHiddenClass, kgIsUnavailable);

      if (kgMeta.available && !kgFirstAvailableInput) {
        kgFirstAvailableInput = kgInput;
      }
    });

    return kgFirstAvailableInput;
  }

  function kgToggleOptionWrapper(kgVariantOptionsElement, kgPosition) {
    const kgInputs = Array.from(
      kgVariantOptionsElement.querySelectorAll(`input[type="radio"][data-position="${kgPosition}"]`),
    );
    if (!kgInputs.length) return;

    const kgVisibleCount = kgInputs.filter((kgInput) => {
      const kgItem = kgGetItemNodeFromInput(kgInput);
      return kgItem && !kgItem.classList.contains(kgHiddenClass);
    }).length;

    const kgOptionWrapper = kgInputs[0].closest(".wt-product__option");
    if (!kgOptionWrapper) return;

    kgOptionWrapper.classList.toggle(kgHiddenWrapperClass, kgVisibleCount <= 1);
  }

  function kgEnsureSelectedAvailable(kgVariantOptionsElement, kgPosition, kgFirstAvailableInput) {
    if (!kgFirstAvailableInput) return false;

    const kgSelected = kgVariantOptionsElement.querySelector(
      `input[type="radio"][data-position="${kgPosition}"]:checked`,
    );

    if (!kgSelected) {
      kgFirstAvailableInput.click();
      return true;
    }

    const kgSelectedItem = kgGetItemNodeFromInput(kgSelected);
    const kgSelectedHidden = kgSelectedItem
      ? kgSelectedItem.classList.contains(kgHiddenClass)
      : false;
    const kgSelectedDisabled = kgSelected.classList.contains("disabled");

    if (kgSelectedHidden || kgSelectedDisabled) {
      kgFirstAvailableInput.click();
      return true;
    }

    return false;
  }

  function kgApplyToVariantOptions(kgVariantOptionsElement) {
    if (!kgVariantOptionsElement) return;
    const kgVariantJson = kgVariantOptionsElement.querySelector('script[type="application/json"]');
    if (!kgVariantJson) return;

    let kgVariants = [];
    try {
      kgVariants = JSON.parse(kgVariantJson.textContent || "[]");
    } catch (kgError) {
      return;
    }
    if (!kgVariants.length) return;

    const kgFirstAvailableOption2 = kgUpdateOptionVisibility(
      kgVariantOptionsElement,
      2,
      kgVariants,
    );
    kgToggleOptionWrapper(kgVariantOptionsElement, 2);
    const kgChanged2 = kgEnsureSelectedAvailable(
      kgVariantOptionsElement,
      2,
      kgFirstAvailableOption2,
    );

    if (kgChanged2) return;

    const kgFirstAvailableOption3 = kgUpdateOptionVisibility(
      kgVariantOptionsElement,
      3,
      kgVariants,
    );
    kgToggleOptionWrapper(kgVariantOptionsElement, 3);
    kgEnsureSelectedAvailable(
      kgVariantOptionsElement,
      3,
      kgFirstAvailableOption3,
    );
  }

  function kgApplyAll() {
    const kgVariantOptionsElements = document.querySelectorAll("variant-options");
    kgVariantOptionsElements.forEach((kgElement) => kgApplyToVariantOptions(kgElement));
  }

  function kgBindVariantEvents() {
    document.addEventListener("variantChangeEnd", function (kgEvent) {
      const kgTarget = kgEvent && kgEvent.target;
      if (!kgTarget || kgTarget.tagName !== "VARIANT-OPTIONS") return;
      kgApplyToVariantOptions(kgTarget);
    });
  }

  function kgInitCustomVariantLogic() {
    kgInjectHideStyle();
    kgBindVariantEvents();
    kgApplyAll();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", kgInitCustomVariantLogic);
  } else {
    kgInitCustomVariantLogic();
  }
  function kgGetScrollOffset() {
    const announcement = document.querySelector(".kg-wt-announcement, .wt-announcement");
    const header = document.querySelector(".kg-page-header, .page-header");
    let offset = 16;

    if (announcement) {
      offset += announcement.offsetHeight;
    }

    if (header) {
      offset += header.offsetHeight;
    }

    return offset;
  }

  function kgGetScrollTargetId(trigger) {
    const scrollTarget = trigger.getAttribute("data-scroll-to");
    if (scrollTarget) {
      return scrollTarget.startsWith("#") ? scrollTarget.slice(1) : scrollTarget;
    }

    const href = trigger.getAttribute("href");
    if (!href || href === "#" || !href.startsWith("#")) {
      return null;
    }

    return href.slice(1);
  }

  function kgSmoothScrollToId(targetId) {
    const target = document.getElementById(targetId);
    if (!target) {
      return false;
    }

    const top =
      target.getBoundingClientRect().top + window.pageYOffset - kgGetScrollOffset();

    window.scrollTo({
      top: Math.max(top, 0),
      behavior: "smooth",
    });

    if (window.history.replaceState) {
      window.history.replaceState(null, "", `#${targetId}`);
    } else {
      window.location.hash = targetId;
    }

    return true;
  }

  function kgInitSmoothScrollToId() {
    document.addEventListener("click", (event) => {
      const trigger = event.target.closest(
        'a[href^="#"]:not([href="#"]), [data-scroll-to]',
      );
      if (!trigger) {
        return;
      }

      const targetId = kgGetScrollTargetId(trigger);
      if (!targetId) {
        return;
      }

      if (!document.getElementById(targetId)) {
        return;
      }

      event.preventDefault();
      kgSmoothScrollToId(targetId);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", kgInitSmoothScrollToId);
  } else {
    kgInitSmoothScrollToId();
  }
})();

